import { Country } from "../postal/country.model";
import { KnownUser } from "./known-user.model";

export class AddressableUser extends KnownUser {
    public static override stringifyExclude: string[] = [
        "_country"
    ];

    private _address_line_1: string = "";
    private _address_line_2: string = "";
    private _address_line_3: string = "";
    private _country_code: string = "";
    private _country: Country = new Country();

    public constructor() {
        super();
    }

    public get address_line_1(): string {
        return this._address_line_1;
    }

    public set address_line_1(value: string) {
        this._address_line_1 = value;
    }

    public get address_line_2(): string {
        return this._address_line_2;
    }

    public set address_line_2(value: string) {
        this._address_line_2 = value;
    }

    public get address_line_3(): string {
        return this._address_line_3;
    }

    public set address_line_3(value: string) {
        this._address_line_3 = value;
    }

    public get country_code(): string {
        return this._country_code;
    }

    public set country_code(value: string) {
        this._country_code = value;
    }

    public get country(): Country {
        return this._country;
    }

    public set country(value: Country) {
        this._country = value;
    }

    public override toJSON(stringifyExclude: string[]) {
        return super.toJSON(AddressableUser.stringifyExclude.concat(stringifyExclude));
    }
}
